/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-08 11:08:53                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-03 12:08:39                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
    * Components
  * ProspectsSection: dashboard section
    * useEffect: get visits data
*/

/* Imports */
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
/***/

/* Services */
import { createDateRangeQuery, searchWithFilters } from "../../../../../services/api/search";
/***/

/* Components */
import DashboardCardLayout from "../DashboardCardLayout";
import Loading from "../../../../../components/loading/Loading";
import ProspectDashCard from "../../../../../components/data/prospect/ProspectDashCard";
/***/

/**
* ProspectsSection: dashboard section
* display prospect summarized informations
*/
export default function ProspectsSection({ from, to }: { from: Date; to: Date }) {
  const navigate = useNavigate();
  const [visits, setVisits] = useState<EasyTech.Prospect[]>();
  const MAX_LENGTH = 3;

  /**
  * useEffect: get visits data
  * reload when the dashboard period changes
  */
  useEffect(() => {
    setVisits(undefined);
    searchWithFilters<EasyTech.Prospect>("prospects", {
      paginate: { pageSize: MAX_LENGTH, pageNumber: 0 },
      order: { by: "date", direction: "DESC" },
      queries: [createDateRangeQuery("date", from, to)]
    })
      .then(ret => setVisits(ret.data))
      .catch(err => {
        console.error(err);
        setVisits([]);
      });
  }, [from, to]);
  /***/

  return(
    <div>
      <DashboardCardLayout  title={t("client:title")}
                            path="/visits">
        <>
          {visits ? 
            visits.length > 0 ?
              visits.slice(0, MAX_LENGTH).map((el) => (
                <ProspectDashCard key={el.id} onClick={() => navigate(`/visits/${el.id}`)} visit={el}/>
              ))
            : <span className="no-item">{t("no visit")}</span>
          : <Loading/>}
        </>
      </DashboardCardLayout>
    </div>
  );  
}
/***/
